import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SetupItemCardNavService {
  securityAndPrivacyOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  introToKinnectOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  onboardingResponsibilityOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  handleNav(val: boolean, type: 'security_and_privacy' | 'intro_to_kinnect' | 'onboarding_responsibility_complete') {
    if (type == 'security_and_privacy') this.securityAndPrivacyOpened.next(val);
    if (type == 'intro_to_kinnect') this.introToKinnectOpened.next(val);
    if (type == 'onboarding_responsibility_complete') this.onboardingResponsibilityOpened.next(val);
  }
}
